import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/redux/api";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import ServiceRequestList from "@/containers/service-request/ServiceRequestList";

export default function FacilityServiceRequestPage() {
  const facilityId = useSelector((state) => state.Facility?.selected?.Id);
  const facilityContext = useSelector((state) => getFacilityContext(state));
  const userFacilities = useSelector((state) => state.Auth?.user_facilities || []);
  const location = useLocation();
  const navigate = useNavigate();
  const facilities = useMemo(() => {
    const facilityMap = new Map();
    userFacilities.forEach((facility) => {
      if (facility?.id != null) facilityMap.set(facility.id, facility);
    });
    return Array.from(facilityMap.values());
  }, [userFacilities]);
  const [facilityIds, setFacilityIds] = useState([]);

  useEffect(() => {
    const allowedIds = new Set(facilities.map((facility) => facility.id));
    const queryIds = new URLSearchParams(location.search)
      .getAll("facility")
      .map(Number)
      .filter((id) => allowedIds.has(id));
    setFacilityIds(queryIds.length ? Array.from(new Set(queryIds)) : facilityId ? [facilityId] : []);
  }, [facilities, facilityId, location.search]);

  const changeFacilities = useCallback((nextFacilityIds) => {
    const nextParams = new URLSearchParams(location.search);
    nextParams.delete("facility");
    nextFacilityIds.forEach((id) => nextParams.append("facility", id));
    setFacilityIds(nextFacilityIds);
    navigate({ pathname: location.pathname, search: nextParams.toString() }, { replace: true });
  }, [location.pathname, location.search, navigate]);
  const loadRequests = useCallback(
    (selectedFacilityIds, params) => api.getFacilityServiceRequests(selectedFacilityIds, params),
    []
  );
  const getDetailPath = useCallback(
    (record) => {
      const path = buildFacilityPath(`service-request-detail/${record.id}`, facilityContext) || "/switch-view";
      const params = new URLSearchParams();
      facilityIds.forEach((id) => params.append("facility", id));
      return params.toString() ? `${path}?${params.toString()}` : path;
    },
    [facilityContext, facilityIds]
  );

  return (
    <ServiceRequestList
      facilityIds={facilityIds}
      facilities={facilities}
      onFacilityChange={changeFacilities}
      loadRequests={loadRequests}
      getDetailPath={getDetailPath}
      showRequesterColumn
    />
  );
}
